import React, {useRef} from 'react'
import { Helmet } from 'react-helmet-async'
import Slick from 'react-slick'
import 'app/theme/slider/slick.css'
import 'app/theme/slider/slick-theme.css'
import { PrevArrow, NextArrow } from 'app/theme/slider/Slider'
import { Layout } from 'app/theme/layout'
import { Mail, Phone, ChevronLeft, ChevronRight } from 'react-feather'

import Slider from 'app/theme/slider'
import BackgroundCover from 'app/theme/BackgroundCover'
import NavbarFixed from 'app/theme/NavbarFixed'
import useLeadModal from './useLeadModal'
import LazyImage from 'app/theme/LazyImage'

import RecentActivations from './RecentActivations'

import bannerImg from './img/banners/notmilk-banner.png'

import styles from './AgencyPage.module.css'

import grid_batiste from './img/branded-trucks-page/intro-grid/batiste.png'
import grid_carnival from './img/branded-trucks-page/intro-grid/carnival.png'
import grid_daring_coachella from './img/branded-trucks-page/intro-grid/daring-coachella.png'
import grid_daring_expo_west from './img/branded-trucks-page/intro-grid/daring-expo-west.png'
import grid_shopify from './img/branded-trucks-page/intro-grid/shopify.png'
import grid_uber_eats from './img/branded-trucks-page/intro-grid/uber-eats.png'

import grid_miley from './img/branded-trucks-page/intro-grid/miley-cyrus-x-magnum.png'
import grid_seinfeld from './img/branded-trucks-page/intro-grid/seinfeld-nyc.png'
import grid_imh from './img/branded-trucks-page/intro-grid/imh-mn.png'

import elements_slideshow_gearbox from './img/branded-trucks-page/elements-slider/gearbox.jpg'
import elements_slideshow_nz_beef from './img/branded-trucks-page/elements-slider/nz-beef.png'
import elements_slideshow_portillos from './img/branded-trucks-page/elements-slider/portillos.png'
import elements_slideshow_publix from './img/branded-trucks-page/elements-slider/publix.png'

import company_types_slideshow_hellokitty from './img/branded-trucks-page/company-types-slider/hello-kitty.png'
import company_types_slideshow_maruchan from './img/branded-trucks-page/company-types-slider/maruchan.jpg'
import company_types_slideshow_snyk from './img/branded-trucks-page/company-types-slider/snyk.png'
import company_types_slideshow_portillos from './img/branded-trucks-page/company-types-slider/portillos.png'
import company_types_slideshow_culvers from './img/branded-trucks-page/company-types-slider/culvers.png'

import howitworks_grid_halotop from './img/branded-trucks-page/how-it-works-grid/halo-top.png'
import howitworks_grid_impossible from './img/branded-trucks-page/how-it-works-grid/impossible.png'
import howitworks_grid_tums from './img/branded-trucks-page/how-it-works-grid/tums.png'

import forkKnife from 'assets/svg/fork-knife.svg'
import taco from 'assets/svg/taco.svg'
import camera from 'assets/svg/camera-old.svg'
import arrowLeft from 'assets/svg/left-arrow-dark.svg'
import arrowRight from 'assets/svg/right-arrow-dark.svg'

import budweiser from './img/logos/budweiser.png'
import pepsi from './img/logos/pepsi.png'
import notco from './img/logos/notco.png'
import impossible from './img/logos/impossible.png'
import sony from './img/logos/sony.png'
import bumble from './img/logos/bumble.png'
import helloKitty from './img/logos/hello-kitty.png'
import vote from './img/logos/vote.png'
import barbie from './img/logos/barbie.png'
import ciroc from './img/logos/ciroc.png'
import shakeshack from './img/logos/shakeshack.png'
import walmart from './img/logos/walmart.png'

const menuItems = [
  {
    title: 'Advantages',
    url: `#advantages`,
  },
  {
    title: 'How it Works',
    url: `#how-it-works`,
  },
  {
    title: 'Types of Companies',
    url: `#types-of-companies`,
  },
  {
    title: 'Case Studies',
    url: `#case-studies`,
  },
  {
    title: 'FAQ',
    url: `#faq`,
  },
]

const googleMetaTags = JSON.stringify(
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "What is a branded food truck?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A branded food truck is a type of experiential marketing vehicle that is wrapped in a company’s branding. The purpose of a branded food truck is to put on an event or serve as a mobile billboard to engage the company’s consumers."
      }
    },{
      "@type": "Question",
      "name": "How much does a branded food truck cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Because there are so many different elements that can go into a branded food truck, the cost of a campaign can be anywhere from $20,000 to over $1 million. These costs may incorporate things like staffing of brand ambassadors, flights, fabrication costs, permitting costs, marketing costs, and other types of factors. The sky is the limit with branded food trucks, and the costs will be determined by how intricate the brand wishes the promotion to be."
      }
    },{
      "@type": "Question",
      "name": "How do I create a branded food truck promotion?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": `A branded food truck promotion is comprised of different elements, which will change depending on what the goals of the brand are, where they want the activation to take place, and what type of experience they want to create for their audience. At a high level, brands planning a food truck activation need to focus on: <ol><li>Having the right equipment, brand ambassadors, infrastructure, and permitting</li><li>Ensuring that you start with clear goals upon which to build your strategy</li><li>Scouting your locations to ensure they will work for your activation (and have permits)</li><li>A great on-the-ground team</li><li>Someone to manage and execute the branded food truck promotion</li><li>A sufficient budget to build and sustain the activation</li></ol>`
      }
    }]
  }
)
export default function BrandedFoodTrucksPage(props) {

  const { Modal, openModal } = useLeadModal()

  const elementSlider = useRef()
  const typeSlider = useRef()

  return (
    <Layout>
      <Helmet>
        <title>Branded Food Trucks - Roaming Hunger</title>
        <meta name="description" content="Create a mobile billboard or an entire brand activation with a branded food truck, trailer, or other vehicles. Our experiential marketing agency will take your brand anywhere you want to be."></meta>
        <meta name="og:title" content={`Branded Food Trucks`}></meta>
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <BackgroundCover imageUrl={bannerImg} className="bg-left md:bg-center">
        <div className={styles.gradient}>
          <div className="container text-white py-20">
            <div className="xl:w-1/2 m-auto">
              <h1 className="font-platform leading-none text-5xl text-center leading-tight mb-6 mt-20">
                Branded Food Trucks
              </h1>
              <p className="hidden md:block text-lg font-light text-center mb-5 leading-relaxed">
                Create a mobile billboard or an entire brand activation that will move your audience. Anywhere.
              </p>
              <p className="block md:hidden text-2xl font-light text-center mb-24 leading-relaxed">
                Take your brand on the road with a mobile experience
              </p>
              <button
                className="btn btn-green font-platform text-2xl px-5 py-2 m-auto block"
                children="Get Started"
                onClick={openModal}
              />
            </div>
          </div>
        </div>
      </BackgroundCover>
      <NavbarFixed
        bgColor="bg-blue"
        className="text-white font-normal text-md"
        buttonStyle="text-white border-white border-2"
        onButtonClick={openModal}
        buttonText="Contact Us"
        menuItems={menuItems}
      />
      <div id="clients" className="bg-white py-12">
        <div className="container text-center">
          <h2 className="font-platform text-3xl text-center text-navy w-full mb-6">
            A Few of Our Branded Food Truck Customers
          </h2>
          <Slider
            arrows={false}
            dots={true}
            slidesToShow={4}
            slidesToScroll={4}
            responsive={[{
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            }]}
          >
            <div className="flex justify-center items-center">
              <img src={budweiser} alt="budweiser-logo" className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={pepsi} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={notco} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={impossible} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={sony} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={bumble} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={helloKitty} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={vote} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={barbie} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={ciroc} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={shakeshack} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={walmart} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
          </Slider>
        </div>
      </div>
      {/* Intro */}
      <section className="bg-white">
        <div className="container max-w-4xl pt-12">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">
            Take your brand to your audience with a mobile experience.
          </h2>
          <p className="mt-6 text-xl md:text-lg leading-relaxed">
            Branded food trucks combine the critical elements of storytelling and allow the brand to surprise and delight its audience, creating a sort of “one-two punch” that leads to a knockout experiential marketing  activation. But there are many things to know about creating a branded food truck, so let’s get into that now…
          </p>
        </div>
        <div className="container max-w-4xl pt-12 md:pb-12 px-0 md:px-5">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-3 lg:gap-6 text-white">
            <img src={grid_shopify} name="Shopify LAX Vid Summit" />
            <img src={grid_uber_eats} name="Uber Eats x Cinco de mayo" />
            <img src={grid_daring_coachella} name="Daring - Coachella" />
            <img src={grid_daring_expo_west} className="hidden md:block" name="Daring - Expo West" />
            <img src={grid_carnival} className="hidden md:block" name="Carnival cruise" />
            <img src={grid_batiste} className="hidden md:block" name="Batiste" />
          </div>
        </div>
      </section>

      {/* What is a Branded Food Truck? */}
      <section>
        <div className="container max-w-4xl py-12">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">
            What is a Branded Food Truck?
          </h2>
          <p className="mt-6 text-xl md:text-lg leading-relaxed">
            A <strong className="font-bold text-black">branded food truck</strong> is a type of experiential marketing vehicle designed to fit your brand or a specfic marketing campaign. The vehicle can be a food truck, trailer, or food cart, and it can be a new food truck build or an existing food truck that is repurposed specifically for your needs.
          </p>
        </div>

        <div className="container max-w-4xl pb-12 flex">
          <div className="flex-1 bg-navy px-4 py-12 md:px-12">
            <p className="text-white italic text-xl md:text-lg leading-relaxed pb-6">
              With over 12 years of experience creating branded food trucks, we can source the best equipment anywhere in the world using our over 23,000 vendors. From graphic design to the vehicle wrap, we’ll set up you up for success from the first step.
            </p>
            <button
              className="btn btn-green font-platform -mb-16 md:mb-0 text-xl px-5 py-2 m-auto block"
              children="Get Started"
              onClick={openModal}
            />
          </div>
        </div>
      </section>

      {/* Advantages/Benefits of a Branded Food Truck */}
      <section id="advantages" className="bg-white">
        <div className="container max-w-4xl py-12 px-0">
          <h2 className="text-3xl text-navy text-center font-platform mb-6 px-5">
            Benefits of Creating a Branded Food Truck
          </h2>
          <p className="pb-6 px-5 text-xl md:text-lg leading-relaxed">
            Branded food trucks can serve as part of a <a className="text-blue underline" href="/experiential-marketing-agency/food-truck-promotions/">food truck promotion</a>, a mobile pop-up shop activation, or as part of a mobile marketing tour. These experiential marketing activations are an excellent option for CPG and food-based brands, as the food trucks come with a kitchen, and are mobile and versatile in footprint. While the centerpiece of a branded food truck is built around a food truck, the experience does not have to be food-related at all.
          </p>
          <img src={grid_imh} name="IMH" className="md:hidden pb-6 w-full"/>
          <p className="px-5 text-xl md:text-lg leading-relaxed">
            The <strong className="font-bold text-black">branded food truck</strong> is a way to extend your brand and to take your marketing campaigns out of the sample aisles at conventions, Costcos, or malls and straight to wherever your audience will be at any given time. When done right, the branded food truck is either wrapped, painted, or outfitted with external fabrications to create both a <strong className="font-bold text-black">mobile billboard</strong> that can reach your audience as it travels, and also an experience for your audience when they are physically at the branded food truck.
          </p>
        </div>

        <div className="container max-w-4xl px-0 pb-6 hidden md:block">
          <div className="grid grid-cols-3 gap-0 text-white">
            <div className="bg-cover h-0" style={{paddingTop:"70%", backgroundImage: `url(${grid_imh})`}}/>
            <div className="bg-cover h-0" style={{paddingTop:"70%", backgroundImage: `url(${grid_seinfeld})`}}/>
            <div className="bg-cover h-0" style={{paddingTop:"70%", backgroundImage: `url(${grid_miley})`}}/>
          </div>
        </div>
      </section>

      {/* Elements of a Branded Food Truck */}
      <section className="container max-w-4xl pt-12 px-0">
        <h2 className="text-3xl text-navy text-center font-platform mb-6 px-5">
          What are the Elements of a Branded Food Truck?
        </h2>
        <p className="pb-6 px-5 text-xl md:text-lg leading-relaxed">
          Here are a few of the elements that make a branded food truck a valuable asset to incorporate into your experiential marketing strategy:
        </p>
        <Slick
          arrows={true}
          className={styles.slider_wrapper}
          dots={false}
          infinite={true}
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          lazyLoad={false}
          prevArrow={<PrevArrow />}
          nextArrow={<NextArrow />}
          ref={slick => (elementSlider.current = slick)}
          responsive={[{
            breakpoint: 768,
            settings: {
              arrows: false
            }
          }]}
        >
          {[
            {
              image: elements_slideshow_publix,
              title: "Visual Experience",
              description: "A stunning wrap can draw attention in a big way and serve as the centerpiece of your events."
            },
            {
              image: elements_slideshow_portillos,
              title: "Staffing",
              description: "A friendly and knowledgeable crew can make any event a smashing success, from set up to tear down."
            },
            {
              image: elements_slideshow_gearbox,
              title: "Mobility",
              description: "Branded food trucks allow you to expand your event marketing in a specific market, or to take your brand on the road with a mobile marketing tour."
            },
            {
              image: elements_slideshow_nz_beef,
              title: "Culinary Experience",
              description: "Having a mobile kitchen allows you to create a multi-sensory experience that captures your consumers sense of taste and smell."
            },
          ].map(advantage => (
            <div key={advantage.title}>
              <img src={advantage.image} className={["m-auto"]}/>
              <div className="md:hidden bg-blue text-white text-lg py-4 flex">
                <div onClick={() => elementSlider.current?.slickPrev()} style={{width: "50px"}}>
                  <ChevronLeft size={30} className="text-white"/>
                </div>
                <p className="flex-1 text-xl md:text-lg text-center">{advantage.title}</p>
                <div onClick={() => elementSlider.current?.slickNext()} style={{width: "50px"}}>
                  <ChevronRight size={30} className="text-white"/>
                </div>
              </div>
              <p className="bg-white text-navy text-xl md:text-lg leading-relaxed font-light px-5 lg:px-10 py-5">
                <span className="font-bold hidden md:inline">{advantage.title} - </span>{advantage.description}
              </p>
            </div>
          ))}
        </Slick>
        <button
          className="btn btn-green font-platform text-xl px-5 py-2 m-auto block"
          children="Get Started"
          onClick={openModal}
        />
      </section>

      {/* Types of Branded Food Trucks */}
      <section className="bg-blue mt-12">
        <div className="container max-w-4xl py-12 px-0">
          <h2 className="text-3xl text-white text-center font-platform mb-6 px-10">
            Types of Branded Food Trucks
          </h2>
          <p className="text-white text-center text-xl md:text-lg leading-relaxed pb-10 px-10">
            Branded food trucks come in all shapes and sizes, and can be properly sourced to best fit a brand’s goals.
          </p>
          <Slick
            arrows={true}
            dots={false}
            infinite={true}
            speed={500}
            slidesToShow={1}
            slidesToScroll={1}
            lazyLoad={false}
            prevArrow={<PrevArrow />}
            nextArrow={<NextArrow />}
            ref={slick => (typeSlider.current = slick)}
            className={styles.company_type_slider}
            responsive={[{
              breakpoint: 768,
              settings: {
                arrows: false
              }
            }]}
          >
            {[
              {
                image: company_types_slideshow_hellokitty,
                title: "Mobile Pop Up Shops",
                description: "These custom vehicles are best for non-food brands."
              },
              {
                image: company_types_slideshow_maruchan,
                title: "Experiential Trailers",
                description: "A retrofitted Airstream can make a stunning visual statement."
              },
              {
                image: company_types_slideshow_snyk,
                title: "Food and Coffee Carts",
                description: "A versatile, small foodpring vehicle that can fit almost anywhere."
              },
              {
                image: company_types_slideshow_culvers,
                title: "Large Footprint Food Trucks",
                description: "A mobile kitchen built for scale that doubles as a billboard."
              },
              {
                image: company_types_slideshow_portillos,
                title: "Retro Style Trucks",
                description: "A visual centerpiece that can draw a crowd on any street corner."
              },
            ].map(company_type => (
              <div key={company_type.title} className="relative">
                <img src={company_type.image} className={["m-auto"]}/>
                <div className={["md:hidden bg-white -mt-10 relative z-1 mx-auto", styles.company_type_caption_sm]}>
                  <div className="flex py-4">
                    <div onClick={() => typeSlider.current?.slickPrev()} style={{width: "50px"}}>
                      <ChevronLeft size={30} className="text-green"/>
                    </div>
                    <p className="flex-1 text-xl md:text-lg text-green text-center">{company_type.title}</p>
                    <div onClick={() => typeSlider.current?.slickNext()} style={{width: "50px"}}>
                      <ChevronRight size={30} className="text-green"/>
                    </div>
                  </div>
                  <p className="text-xl md:text-lg leading-relaxed px-5 pb-5">{company_type.description}</p>
                </div>

                <p
                  className={[
                    "bg-white hidden lg:block lg:absolute text-navy text-sm font-light p-4",
                    styles.company_type_caption
                  ]}
                >
                  <span className="font-bold text-lg font-platform text-green block text-center">
                    {company_type.title}
                  </span>
                  {company_type.description}
                </p>
              </div>
            ))}
          </Slick>
          <p className="text-white text-xl md:text-lg leading-relaxed py-10 px-5">
            Is your brand solely focused on giving out a large number of food-based samples? If so, the branded food truck needs to be selected with logistics in mind, ensuring that it can keep up with your required timeline and samples.
          </p>
          <p className="text-white text-xl md:text-lg leading-relaxed pb-10 px-5">
            Is your brand’s goal more focused on the marketing aspect rather than the samples? If so, a branded food truck can be selected that focuses more on the ability to brand the truck based on size and shape rather than the kitchen.
          </p>
          <button
            className="text-white border-white border-2 font-platform text-lg px-5 py-2 m-auto mt-5 block"
            children="Get Started"
            onClick={openModal}
          />
        </div>
      </section>

      {/* How a Branded Food Truck Works */}
      <section id="how-it-works" className="bg-white">
        <div className="container max-w-4xl pt-12">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">
            How a Branded Food Truck Works
          </h2>
          <p className="mt-6 text-xl md:text-lg leading-relaxed">
            A branded food truck offers the ability to extend your brand, to take it beyond the billboard, the direct mailer, or the digital ad appearing on someone’s browser or social media feed. It allows your brand to connect with your customers offline and in the real world. Because branded food trucks are mobile, they also offer the ability to serve as a mobile billboard that can be taken to exactly where local expertise tells you that your customer base or potential customers are likely to be at a given time and day.
          </p>
          <p className="mt-6 text-xl md:text-lg leading-relaxed">
            In our over 12 years of experience, we’ve learned that successful branded food trucks craft an experience that people remember, talk about, and most importantly, <strong className="text-black font-bold">share</strong>.
          </p>
          <div className="my-12">
            <h3 className="pb-6 font-platform text-xl text-blue text-center">
              Here are a few things to think about when creating a branded food truck:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="flex">
                <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>1</label>
                <p className="flex-1 font-light text-lg leading-relaxed">
                  <span className="font-bold">Source the right equipment.</span> If you’re putting on a big experiential marketing activation, get a large scale food truck that will stand out. If you’re fitting into small spaces, get a food cart that can do the job.
                </p>
              </div>
              <div className="flex">
                <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>2</label>
                <p className="flex-1 font-light text-lg leading-relaxed">
                  <span className="font-bold">Wrap it up.</span> Getting the vehicle wrap wrong can be a costly mistake. Make sure it looks great by working with a designer and creative team that has experience creating branded food trucks.
                </p>
              </div>
              <div className="flex">
                <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>3</label>
                <p className="flex-1 font-light text-lg leading-relaxed">
                  <span className="font-bold">Know your budget.</span> Unless your budget is unlimited, have a range in mind so that we can let you know what’s possible.
                </p>
              </div>
              <div className="flex">
                <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>4</label>
                <p className="flex-1 font-light text-lg leading-relaxed">
                  <span className="font-bold">Get the right permits and legal documents.</span> Make sure that you don’t get shut down before you pass out the first sample.
                </p>
              </div>
              <div className="flex">
                <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>5</label>
                <p className="flex-1 font-light text-lg leading-relaxed">
                  <span className="font-bold">Hire a great on-the-ground team.</span> Whether you need chefs on the truck or brand ambassadors delighting passersby, you need the right people to set up, put on the activation, and break down the entire experience.
                </p>
              </div>
              <div className="flex">
                <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>6</label>
                <p className="flex-1 font-light text-lg leading-relaxed">
                  <span className="font-bold">Utilize local knowledge.</span> If you’re going to new markets, use local experts that can help you get the details right, from locations and hours to food and operations.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container max-w-4xl pb-6">
          <p className="mt-6 text-xl md:text-lg leading-relaxed">
            Branded food trucks also provide the ability to control the experience and perception that your audience takes away from the experience (far greater than most sampling or giveaway campaigns provide). They can provide a brand with valuable insights into how it is perceived by the audience, the way in which your audience interacts, and capture data through a variety of real-world methods offered directly by your customers. Because branded food trucks are extremely mobile, they even offer the ability to test different locations within the same region on the same day, serving as a mobile billboard while extending your brand throughout an area.
          </p>
        </div>
        <div className="container max-w-4xl my-12 bg-navy py-12">
          <p className="text-white italic text-xl md:text-lg leading-relaxed pb-6">
            Our DNA is in the food truck industry. Since 2009, we’ve built a network of over 23,000 food trucks, trailers, and carts all over the world. Our experience will save you time and budget because we’ll only hand you the keys when every single detail is taken care of.
          </p>
          <button
            className="btn btn-green font-platform -mb-16 md:mb-0 text-xl px-5 py-2 m-auto block"
            children="Get Started"
            onClick={openModal}
          />
        </div>

        <img src={howitworks_grid_halotop} name="Halo Top" className="md:hidden pb-6 w-full"/>

        <div className="container max-w-4xl pt-12 px-0 hidden md:block">
          <div className="grid grid-cols-3 gap-0 text-white">
            <div className="bg-cover h-0" style={{paddingTop:"70%", backgroundImage: `url(${howitworks_grid_halotop})`}}/>
            <div className="bg-cover h-0" style={{paddingTop:"70%", backgroundImage: `url(${howitworks_grid_impossible})`}}/>
            <div className="bg-cover h-0" style={{paddingTop:"70%", backgroundImage: `url(${howitworks_grid_tums})`}}/>
          </div>
        </div>
      </section>

      {/* Companies */}
      <section id="types-of-companies" className="container max-w-4xl my-12">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">
          What Types of Companies Benefit from Branded Food Trucks?
        </h2>

        <div className="grid gap-5 md:gap-10 sm:grid-cols-2 md:grid-cols-3 my-12">
          <div className="p-5 bg-white shadow border border-gray text-center">
            <img src={taco} className={[styles.what_we_do_icons, 'mb-5 m-auto']}/>
            <h3 className="text-xl text-center text-blue font-platform font-light">Food and Beverage</h3>
            <p className="font-light text-xl md:text-lg leading-relaxed">
              Take your product to where your customers are to grow brand affinity or get instant feedback for new items.
            </p>
          </div>

          <div className="p-5 bg-white shadow border border-gray text-center">
            <img src={forkKnife} className={[styles.what_we_do_icons, 'mb-5 m-auto']}/>
            <h3 className="text-xl text-center text-blue font-platform font-light">Restaurants</h3>
            <p className="font-light text-xl md:text-lg leading-relaxed">
              Step away from the traditional brick & mortar and take your menu items on the road to attract new customers.
            </p>
          </div>

          <div className="p-5 bg-white shadow border border-gray">
            <img src={camera} className={[styles.what_we_do_icons, 'mb-5 m-auto']}/>
            <h3 className="text-xl text-center text-blue font-platform font-light">CPG</h3>
            <p className="font-light text-xl md:text-lg leading-relaxed">
              Extend your brand beyond the stores, and use branded food trucks to deliver limited edition items or to provide an experience for your customers.
            </p>
          </div>
        </div>

        <p className="pb-6 text-xl md:text-lg leading-relaxed">
          Branded food trucks provide the unique ability to extend a brand beyond the walls of a brick & mortar store, taking your products on the road to where your customers or audience are. These vehicles are a natural fit for food and beverage or restaurant brands, but can also be utilized for the “surprise & delight” factor by CPG and other brands as well.
        </p>
        <p className="pb-6 text-xl md:text-lg leading-relaxed">
          We’ve worked with brands in the financial industry, CPG, tech sector, entertainment (movies, television, and music), telecommunications, hospitality, travel, and many others. We’ve learned that the only limiting factor for a branded food truck is your imagination.
        </p>
        <p className="pb-6 text-xl md:text-lg leading-relaxed">
          The ability to build an experience and take it to where your customers are makes this type of experiential marketing activation a valuable asset for any brand looking to connect with its audience, test new products, or introduce itself to new potential customers.
        </p>
      </section>

      {/* Case Studies */}
      <section id="case-studies" className="bg-white" >
        <div className="container max-w-4xl mt-12 p-12">
          <RecentActivations
            case_study_tags={['branded_food_truck']}
          />
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="bg-navy py-12 text-white">
        <div className="container max-w-4xl m-auto">
          <h2 className="text-3xl text-center font-platform mb-6">
            Frequently Asked Questions
          </h2>
          <h3 className="text-2xl font-platform mb-4">
            What is a branded food truck?
          </h3>
          <p className="font-light mb-4 text-xl md:text-lg leading-relaxed">
            A branded food truck is a type of experiential marketing vehicle that is wrapped in a company’s branding. The purpose of a branded food truck is to put on an event or serve as a mobile billboard to engage the company’s consumers.
          </p>
          <h3 className="text-2xl font-platform mb-4">
            How much does a branded food truck cost?
          </h3>
          <p className="font-light mb-4 text-xl md:text-lg leading-relaxed">
            Because there are so many different elements that can go into a branded food truck, the cost of a campaign can be anywhere from $20,000 to over $1 million. These costs may incorporate things like staffing of brand ambassadors, flights, fabrication costs, permitting costs, marketing costs, and other types of factors. The sky is the limit with branded food trucks, and the costs will be determined by how intricate the brand wishes the promotion to be.
          </p>
          <h3 className="text-2xl font-platform mb-4">
            How do I create a branded food truck promotion?
          </h3>
          <p className="font-light mb-4 text-xl md:text-lg leading-relaxed">
            A branded food truck promotion is comprised of different elements, which will change depending on what the goals of the brand are, where they want the activation to take place, and what type of experience they want to create for their audience. At a high level, brands planning a food truck activation need to focus on:
          </p>
          <ol className="list-disc pl-4 font-light text-xl md:text-lg leading-relaxed">
            <li className="">Having the right equipment, brand ambassadors, infrastructure, and permitting</li>
            <li>Ensuring that you start with clear goals upon which to build your strategy</li>
            <li>Scouting your locations to ensure they will work for your activation (and have permits)</li>
            <li>A great on-the-ground team</li>
            <li>Someone to manage and execute the food truck promotion</li>
            <li>A sufficient budget to build and sustain your activation.</li>
          </ol>
          <p className="font-light my-4 text-xl md:text-lg leading-relaxed">
            A branded food truck can provide an engaging, immersive, and memorable experience for your audience and potential future customers. The keys listed above to creating, managing, and executing a successfully branded food truck can be the difference between one that leaves your customers with a lasting impression versus one that they soon forget. Taking the time to plan the activation accordingly, focusing on the experience that your audience will take away, and having an experienced on-the-ground team can make all of the difference with these experiential marketing activations.
          </p>
        </div>
      </section>

      <div className="bg-blue text-white text-center py-12 px-6">
        <h3 className="text-3xl font-platform mb-4">Ready to Launch a Branded Food Truck?</h3>
        <p className="text-md pb-5"><Phone className="inline" size={16} /> (424) 777-2550</p>
        <p className="text-md pb-5"><Mail className="inline" size={16} /> rmng@roaminghunger.com</p>
        <button
          className="btn btn-navy font-platform text-md mt-2 px-5 py-2"
          children="Contact Us"
          onClick={openModal}
        />
      </div>
      <Modal />
    </Layout>
  )
}
